// Define all your HTML blocks as strings in an array
const promoBlocks = [
    `<div class="d-flex text-white justify-content-center text-center">
        <span class="fs-6">
            <span class="fw-bold fs-5">Free Ground Shipping up to $75</span>  <span class="d-none d-lg-inline-block">|</span>  <br class="d-lg-none" /><strong>Coupon code: FREESHIP2026</strong> <span class="d-none d-lg-inline-block">|</span> <br class="d-lg-none" /> Valid for one-time use by 12/31/2026 <span class="d-none d-lg-inline-block">|</span> <br class="d-lg-none" /> <small>Minimum order $500
        </span>
    </div>`
    ,
    `<div class="d-flex text-white justify-content-center text-center">
        <span class="fs-6">
            <span class="fw-bold fs-5">GET FREE SAMPLES</span><span class="d-none d-lg-inline-block">:</span> <br class="d-lg-none" />Order by phone or online from any product page.            
        </span>
     </div>`  
    /*Add as many blocks as you want…*/
];

// Function to pick one at random
function pickRandomBlock(blocks) {
    if (!blocks.length) return ""; // nothing if no blocks
    if (blocks.length === 1) return blocks[0]; // just return it
    const index = Math.floor(Math.random() * blocks.length);
    return blocks[index];
}

// On DOM load, replace the content
document.addEventListener("DOMContentLoaded", function () {
    const container = document.getElementById("js-tag-header-promo");
    if (container) {
        container.innerHTML = pickRandomBlock(promoBlocks);
    }
});
